function removeSpecialCharacters(str) {
  const regex = /[^a-zA-Z0-9]/g;

  const result = str.replace(regex, "");

  return result;
}

export default removeSpecialCharacters;
